import { useCallback } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { queryInvalidationUtils } from "../utils/queryInvalidation";

type RetryType = "tasks" | "transitions";

/**
 * Custom hook for handling retry functionality with appropriate query invalidation
 */
export const useRetry = (type: RetryType, transitionId?: string) => {
  const queryClient = useQueryClient();

  const handleRetry = useCallback(() => {
    switch (type) {
      case "tasks":
        queryInvalidationUtils.invalidateTaskQueries(queryClient);
        break;
      case "transitions":
        queryInvalidationUtils.invalidateTransitionQueries(
          queryClient,
          transitionId
        );
        break;
      default:
        // Fallback - should never happen with proper typing
        queryClient.invalidateQueries();
    }
  }, [queryClient, type, transitionId]);

  return { handleRetry };
};
